interface AdditionalDetailProps {
  detailTitle: string;
  detailValue: string;
}

export function AdditionalDetail({
  detailValue,
  detailTitle,
}: AdditionalDetailProps) {
  return (
    <>
      <h3
        style={{
          marginBottom: 0,
          textTransform: 'uppercase',
          color: '#ABABAB',
          fontSize: '0.75em',
        }}
      >
        {detailTitle}
      </h3>
      <span style={{ fontSize: '1em', color: 'primary.main' }}>
        {detailValue}
      </span>
    </>
  );
}
